import { BETA_FEATURE_LLM_EVAL } from '@/lib/betaFeatures';
import { APPLICATION_TYPE } from '@shared/constants';
import useBetaFeatureEnabled from './useBetaFeatureEnabled';
import { useCurrentUserContext } from './useCurrentUserContext';

export const useIsSelectedAppLLM = () => {
  const { user } = useCurrentUserContext();
  const isLLMEvalEnabled = useBetaFeatureEnabled(BETA_FEATURE_LLM_EVAL);

  return isLLMEvalEnabled ? user?.userAppType === APPLICATION_TYPE.llm : false;
};
